import React from 'react';
import Button from '../ui/button/Button';
import { useTranslation } from 'react-i18next';

interface FormCloseConfirmationProps {
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const FormCloseConfirmation: React.FC<FormCloseConfirmationProps> = ({
  isVisible,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className="fixed inset-0 z-[100000] flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-full max-w-md rounded-lg bg-white p-6 dark:bg-gray-800">
        <h3 className="mb-4 text-xl font-semibold text-gray-800 dark:text-white">
          {t('form.close_confirmation.title')}
        </h3>
        <p className="mb-6 text-gray-500 dark:text-gray-400">
          {t('form.close_confirmation.message')}
        </p>
        <div className="flex justify-end gap-3">
          <Button
            variant="outline"
            size="sm"
            onClick={onCancel}
          >
            {t('form.close_confirmation.continue_editing')}
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={handleConfirm}
          >
            {t('form.close_confirmation.close_without_saving')}
          </Button>
        </div>
      </div>
    </div>
  );
};
